export default "__VITE_ASSET__aacca430__"